import {Nullish} from 'shared/web';

export const formatIban = (iban: string | Nullish) => iban?.replace(/\s/g, '') || null;
